import clsx from 'clsx';
import { useIntl } from 'react-intl';
import type {
  GroupBase,
  NoticeProps as ReactNoOptionsMessageProps,
} from 'react-select';

import { _canReceiveDefaultTextFormat } from '@dynatrace/strato-components/core';
import { Text } from '@dynatrace/strato-components/typography';

import { selectNoOptionsMessageCSS } from '../styles/Select.sty.js';

type NoOptionsMessageProps<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
> = ReactNoOptionsMessageProps<OptionValue, isMulti, Group>;

export function NoOptionsMessage<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
>(props: NoOptionsMessageProps<OptionValue, isMulti, Group>) {
  const selectEmptyState = props.selectProps.emptyState?.props.children;
  const { className: consumerClassName, style: consumerStyle } =
    props.selectProps.componentProps.emptyState ?? {};
  const intl = useIntl();

  if (!selectEmptyState || _canReceiveDefaultTextFormat(selectEmptyState)) {
    return (
      <Text
        textStyle="base"
        style={consumerStyle}
        className={clsx(selectNoOptionsMessageCSS, consumerClassName)}
        as="p"
      >
        {selectEmptyState ??
          intl.formatMessage({
            defaultMessage: 'No items found.',
            id: 'ZYdCWJSSKEkwsXkW',
            description:
              'Default message when no options are available in the select.',
          })}
      </Text>
    );
  } else {
    return (
      <Text
        textStyle="base"
        style={consumerStyle}
        className={clsx(selectNoOptionsMessageCSS, consumerClassName)}
        as="p"
      >
        {selectEmptyState}
      </Text>
    );
  }
}
